import { setupAbstractContentBuilder } from './AbstractContentBuilder.js';
import { addCollapsibleList } from './collapsible-list-builder-api.js';
import { addNode, addListNode, addTextNode } from './node-builder-methods.js';
import { addTable } from './table-builder-api.js';
import 'lodash';
import 'ricos-schema';
import 'ricos-schema/dist/statics/bulleted_list.defaults.json';
import 'ricos-schema/dist/statics/ordered_list.defaults.json';
import '../converters/nodeUtils.js';
import '../ReadonlyNonEmptyArray-0e481d0b.js';
import '../string-40bcd6bf.js';
import 'uuid';
import '../utils.js';
import '../converters/generateRandomId.js';
import './builder-utils.js';
import '../Either-48abb652.js';
import '../fp-utils-24a5cc96.js';
import './modify.js';
import '../modifier-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const firstLetterUpperCase = (str) => `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
const setupContentBuilder = (generateId) => {
  class RicosContentBuilder {
  }
  const builderApis = setupAbstractContentBuilder(
    generateId,
    addTextNode,
    addListNode,
    addNode,
    addTable,
    addCollapsibleList,
    (name) => `add${firstLetterUpperCase(name)}`
    // addParagraph, addTable, ...
  );
  return __spreadValues({
    RicosContentBuilder
  }, builderApis);
};

export { setupContentBuilder };
//# sourceMappingURL=RicosContentBuilder.js.map
